<template>
  <div class="Help">
    <section-header heading="2" ja="ヘルプ"/>
    <normal-btn @click="onHowToUse">プリクラONの使い方</normal-btn>
    <normal-btn @click="onAboutAppli">アプリ版プリクラONについて</normal-btn>
    <normal-btn @click="onFAQ">よくある質問</normal-btn>
    <normal-btn @click="onContact">お問い合わせ</normal-btn>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import MaintenanceCheck from '../mixins/maintenancecheck';
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "Help",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
  },
  mixins: [Protobuf,MaintenanceCheck],
  mounted () {
    sessionStorage.setItem('prevPage', '/Help');
    this.maintenanceCheck();
  },
  methods: {
    onHowToUse() {
      this.$router.push("/Tutorial")
    },
    onFAQ() {
      this.$router.push("/faq")
    },
    onContact() {
      window.open(process.env.VUE_APP_CONTACT_US_URL, "_blank")
    },
    onBack() {
        this.$router.push('/')
    },
    onAboutAppli() {
      this.$router.push('/AboutApplication')
    }
  }
}
</script>

<style scoped>
</style>
